import {get} from 'lodash'

export const waitForProp = <T = any>(
  baseObject: any,
  path: string,
  delayMillis: number
): Promise<T> => {
  return new Promise<T>((resolve) => {
    function resolveIfFound(): boolean {
      const prop = get(baseObject, path) as T
      if (prop !== undefined) {
        resolve(prop)
        return true
      } else {
        return false
      }
    }

    if (!resolveIfFound()) {
      const interval = setInterval(() => {
        if (resolveIfFound()) {
          clearInterval(interval)
        }
      }, delayMillis)
    }
  })
}